import { useAppSelector } from "@/redux/hooks";
import { AddCircleOutlineIcon } from "@brandclub/common-ui";
import { ButtonBase } from "@mui/material";
import {
  BillingDetails,
  LineItem,
  PaymentMethod,
  ShippingAddress,
  ShippingRate,
  StripeExpressCheckoutElementShippingAddressChangeEvent,
  StripeExpressCheckoutElementShippingRateChangeEvent,
} from "@stripe/stripe-js";
import { useState } from "react";
import {
  StripeCardCheckout,
  StripeExpressCheckout,
} from "../../../../../../../Stripe";

import { ResponsiveDialog } from "@/components/StoreComponents/StoreDialogs/ResponsiveDialog";

export const MobileStripePaymentForm = ({
  onSuccess,
  onError,
  onShippingAddressChange,
  onShippingRateChange,
  shippingRates,
  lineItems,
}: {
  onCancel: () => void;
  onSuccess: (
    paymentMethod: PaymentMethod,
    shippingAddress?: ShippingAddress,
    billingDetails?: BillingDetails
  ) => void;
  onError: (error: Error) => void;
  onShippingAddressChange: (
    event: StripeExpressCheckoutElementShippingAddressChangeEvent
  ) => void;
  onShippingRateChange: (
    event: StripeExpressCheckoutElementShippingRateChangeEvent
  ) => void;
  shippingRates: ShippingRate[];
  lineItems: LineItem[];
}) => {
  const user = useAppSelector((state) => state.userProfile);
  const [openPaymentMethodDrawer, setOpenPaymentMethodDrawer] = useState(false);

  if (!user) {
    return null;
  }

  return (
    <>
      <div style={{ marginBottom: "20px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "14px",
            color: "#666",
            fontWeight: 500,
            marginBottom: "16px",
          }}
        >
          Express checkout
        </div>
        <StripeExpressCheckout
          onSuccess={onSuccess}
          onError={onError}
          onShippingAddressChange={onShippingAddressChange}
          onShippingRateChange={onShippingRateChange}
          shippingRates={shippingRates}
          lineItems={lineItems}
        />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          margin: "20px 0",
          color: "#666",
        }}
      >
        <div
          style={{
            flex: 1,
            height: "1px",
            backgroundColor: "#dcdddc",
          }}
        />
        <span
          style={{
            margin: "0 16px",
            fontSize: "14px",
          }}
        >
          OR
        </span>
        <div
          style={{
            flex: 1,
            height: "1px",
            backgroundColor: "#dcdddc",
          }}
        />
      </div>
      <ButtonBase
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          fontWeight: 500,
          width: "100%",
        }}
        onClick={() => {
          setOpenPaymentMethodDrawer(true);
        }}
      >
        <AddCircleOutlineIcon className="add_new_icon" />
        Add a credit card
      </ButtonBase>

      <ResponsiveDialog
        open={openPaymentMethodDrawer}
        onClose={() => setOpenPaymentMethodDrawer(false)}
      >
        <StripeCardCheckout
          onSuccess={onSuccess}
          onError={onError}
          onShippingAddressChange={onShippingAddressChange}
          onShippingRateChange={onShippingRateChange}
          shippingRates={shippingRates}
          onCancel={() => {
            setOpenPaymentMethodDrawer(false);
          }}
        />
      </ResponsiveDialog>
    </>
  );
};
